export default {"src":"/_next/static/media/download__image_icon.ff8afaa8.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};